import {
  isStringBBToolPaletteStencilId,
  isStringHKToolPaletteStencilId,
  isStringSCToolPaletteStencilId,
} from "../../config";
import { PositionLabelType } from "../../pages";
import { Sport } from "../../redux/slices";
import { FrameStencil, Play, Point } from "../../types";
import { createBasketballStencilFromToolPalette } from "./create-basketball-stencil-from-tool-palette";
import { createHockeyStencilFromToolPalette } from "./create-hockey-stencil-from-tool-palette";
import { createSoccerStencilFromToolPalette } from "./create-soccer-stencil-from-tool-palette";

export interface CreateStencilFromToolPaletteProps {
  id: string;
  positionLabelType: PositionLabelType;
  pos: Point;
  sport: Play["sport"];
}

export const createStencilFromToolPalette = ({
  id,
  positionLabelType,
  pos,
  sport,
}: CreateStencilFromToolPaletteProps): FrameStencil | null => {
  switch (sport) {
    case Sport.BASKETBALL: {
      if (!isStringBBToolPaletteStencilId(id)) return null;
      return createBasketballStencilFromToolPalette({ id, pos });
    }

    case Sport.HOCKEY: {
      if (!isStringHKToolPaletteStencilId(id) || positionLabelType.sport !== Sport.HOCKEY) return null;
      return createHockeyStencilFromToolPalette({ id, positionLabelType: positionLabelType.labelType, pos });
    }

    case Sport.SOCCER: {
      if (!isStringSCToolPaletteStencilId(id) || positionLabelType.sport !== Sport.SOCCER) return null;
      return createSoccerStencilFromToolPalette({ id, positionLabelType: positionLabelType.labelType, pos });
    }
  }
};
